/**
 * The type of the redux action which webview in picture in picture mode of it's current state.
 *
 * {
 *     type: SET_IS_IN_WEBVIEW_PICTURE_IN_PICTURE_MODE
 * }
 * @public
 */
export const SET_IS_IN_WEBVIEW_PICTURE_IN_PICTURE_MODE = 'SET_IS_IN_WEBVIEW_PICTURE_IN_PICTURE_MODE';
